$(function() {

//==========================================================================
// MODULE STATE
//==========================================================================

var docEl;
var percentToShow;
var isShown;
var forcedHidden;
var $window;
var $document;
var $components;
var scrollHeight;
var threshold;

//==========================================================================
// ENTRY POINT
//==========================================================================

init();

//==========================================================================
// INIT
//==========================================================================

//-----

function init() {
    // init module state
    initModuleState();

    // if there are no related components on the page, return
    if (!$components.length) return;

    // when the scroll height changes, update the value
    $window.on('resize', updateState);

    // for each component, do stuff
    __($components).each(manageComponent);
}

//-----

//==========================================================================
// FUNCTIONS
//==========================================================================

//-----

function initModuleState() {
    $window       = $(window);
    $document     = $(document);
    $components   = $('section.contenido-otra-informacion');
    docEl         = document.documentElement;
    percentToShow = 150;
    isShown       = false;
    forcedHidden  = false;
    scrollHeight  = $document.height() - $window.height() - $("footer").height();
    threshold     = scrollHeight - percentToShow;
    //sessionStorage = window.sessionStorage;
}

//-----

function manageComponent(component) {
    var $component = $(component);
    var $close     = $component.find('button.close');

    // on scroll manage toggling the box
    $window.on('scroll', __(manageShow).partial(__, $component));

    // on close, hide
    $close.on('click', __(hide).partial(__, $component));
}

//-----

function isHidden($component) {
    return forcedHidden ||
        canPersist($component) && !!sessionStorage[$component.attr('id')];
}

//-----

function canPersist($component) {
    return !!sessionStorage && !!$component.attr('id');
}

//-----

function setHidden($component) {
    // fallback for when there's no persistence
    forcedHidden = true;

    // create key for this component and this id
    canPersist($component) &&
        (sessionStorage[$component.attr('id')] = "wasClosed");
}

//===== Events =============================================================

//-----

function updateState(event) {
    scrollHeight = $document.height() - $window.height() - $("footer").height();
    threshold = scrollHeight - percentToShow;
}

//-----

function manageShow(event, $component) {
    // if it was hidden manually, do nothing
    if (isHidden($component)) return;

    // when up and shown, toggle; when down and hidden, toggle
    if (isShown === $window.scrollTop() < threshold) {
        $component.toggleClass('slide-show');
        isShown = !isShown;
    }
}

//-----

function hide(event, $component) {
    $component.removeClass('slide-show');
    setHidden($component);
}

//-----

});
